import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddBillingInfoModalVisibility,
  setManageSubscriptionModalVisibility,
  setPlanUpgradeNeededModalContext,
  setSubscriptionContactModalDisplayMode,
  setSubscriptionUsageModalMode,
  setUnlockAddonsModalVisibility,
} from "src/redux/subscription/subscriptionActions";
import { RootState } from "src/redux/reducers";
import SuccessModal from "src/app/modals/SuccessModal/SuccessModal";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import AddBillingInfoModal from "src/app/modals/AddBillingInfoModal/AddBillingInfoModal";
import ManageSubscriptionModal from "../../modals/ManageSubscriptionModal/ManageSubscriptionModal";
import PlanUpgradeNeededModal from "../../modals/PlanUpgradeNeededModal/PlanUpgradeNeededModal";
import SubscriptionUsageModal from "../../modals/SubscriptionUsageModal/SubscriptionUsageModal";
import { SubscriptionContactSupportModal } from "../../modals/SubscriptionContactSupportModal/SubscriptionContactSupportModal";
import UnlockAddonsModal from "../../modals/UnlockAddonsModal/UnlockAddonsModal";

function SubscriptionModals() {
  const [successModalVisible, setSuccessModalVisible] = useState(false);

  const {
    subscriptionContactModalDisplayMode,
    subscriptionUsageModalMode,
    manageSubscriptionModalVisible,
    planUpgradeNeededModalContext,
    unlockAddonsModalVisibility,
    addBillingInfoModalVisibility,
    subscriptionPlan,
  } = useSelector((state: RootState) => state.subscriptionReducer);

  const dispatch = useDispatch();

  return (
    <>
      {Boolean(subscriptionContactModalDisplayMode) && (
        <SubscriptionContactSupportModal
          onClose={() => dispatch(setSubscriptionContactModalDisplayMode(null))}
          demandPermission={
            subscriptionContactModalDisplayMode === "demandPermission"
          }
        />
      )}

      {subscriptionUsageModalMode && (
        <SubscriptionUsageModal
          onClose={() => dispatch(setSubscriptionUsageModalMode(null))}
          mode={subscriptionUsageModalMode}
        />
      )}

      {planUpgradeNeededModalContext && (
        <PlanUpgradeNeededModal
          onClose={() => dispatch(setPlanUpgradeNeededModalContext(null))}
        />
      )}

      {manageSubscriptionModalVisible && (
        <ManageSubscriptionModal
          onClose={() => dispatch(setManageSubscriptionModalVisibility(false))}
        />
      )}

      {unlockAddonsModalVisibility && (
        <UnlockAddonsModal
          onClose={() => dispatch(setUnlockAddonsModalVisibility(false))}
          openSuccessModal={() => setSuccessModalVisible(true)}
        />
      )}

      {successModalVisible && (
        <SuccessModal onClose={() => setSuccessModalVisible(false)}>
          <IDHFormattedMessage
            id="ws_you_have_successfully_changed_plan_to"
            defaultMessage="You've successfully changed plan to:"
          />{" "}
          {subscriptionPlan?.name}.
        </SuccessModal>
      )}

      {addBillingInfoModalVisibility && (
        <AddBillingInfoModal
          onClose={() => dispatch(setAddBillingInfoModalVisibility(false))}
        />
      )}
    </>
  );
}

export default SubscriptionModals;
